export enum RangeItemDirection {
  From = 'from',
  To = 'to',
}

export enum RangeItemPosition {
  Start = 'start',
  End = 'end',
}

export enum RangeItem {
  StartingChapter = 'starting-chapter',
  StartingVerse = 'starting-verse',
  EndingChapter = 'ending-chapter',
  EndingVerse = 'ending-verse',
}
